import { TGetMaintenanceResDto } from "@/api/services/global/maintenance/dtos/get-maintenance.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { globalApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchMaintenanceInfoApi = async (): Promise<TGetMaintenanceResDto> => {
  const rs = await globalApi.get<TGetMaintenanceResDto>("/maintenance");
  return rs.data;
};

export const useMaintenanceInfo = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.FETCH_MAINTENANCE],
    queryFn: () => fetchMaintenanceInfoApi(),
  });
};
